import { render } from "./jiangqiguanli.vue?vue&type=template&id=d5011a00&scoped=true"
import script from "./jiangqiguanli.vue?vue&type=script&lang=js"
export * from "./jiangqiguanli.vue?vue&type=script&lang=js"

import "./jiangqiguanli.vue?vue&type=style&index=0&id=d5011a00&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5011a00"]])

export default __exports__